import styled from 'styled-components'

import { colors } from '../../theme'

import Loader from '../../controls/Loader'
import Icons from '../../assets/Icons'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  // background-color: var(--color-gray-light);
  // width: 96px;
  // height: 96px;
  .fileIcon {
    color: #91afdb;
    width: 32px;
    height: 36px;
  }
`

export const FileIcon = (props) => {
  const { name, thumbnail, inProgress, className = '' } = props
  function renderFileType() {
    if (name.match(/\.pdf$/i)) {
      return <Icons toolName="pdfFolder" className="pdfFolderIcon" />
    }
    if (name.match(/\.doc(x)?$/i)) {
      return <Icons toolName="docFolder" className="docFolderIcon" />
    }
    if (name.match(/\.ppt(x)?$/i)) {
      return <Icons toolName="pptFolder" className="pptFolderIcon" />
    }
    if (name.match(/\.xls(x)?$/i)) {
      return <Icons toolName="excelFolder" className="xlsFolderIcon" />
    }
    if (name.match(/\.png$/i)) {
      return <Icons toolName="pngFolder" className="pngFolderIcon" />
    }
    if (name.match(/\.(jpg|jpeg)?$/i)) {
      const ext = name.split('.').pop()?.toUpperCase()
      return (
        <Icons
          toolName="jpgFolder"
          className="jpgFolderIcon"
          options={{ ext }}
        />
      )
    }
    if (name) {
      const ext =
        name.lastIndexOf('.') !== -1
          ? name.slice(name.lastIndexOf('.') + 1).toUpperCase()
          : ''
      return (
        <div className="unknownIconFolder">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 36">
            <path
              class="st3"
              d="M30.83,9.25v21.7c0,1.68-1.4,2.99-2.99,2.99H7.16c-1.68,0-2.99-1.4-2.99-2.99V4.76c0-1.68,1.31-3.09,2.99-3.09h16.09c.47,0,1.03.19,1.31.56l5.71,5.61c.28.37.56.84.56,1.4Z"
            />
            <path
              class="st2"
              d="M31.2,7.33l-5.99-5.8c-.28-.37-.84-.56-1.31-.56H7.07c-1.78,0-3.18,1.4-3.18,3.18h0v27.32c0,1.78,1.4,3.18,3.18,3.18h21.61c1.78,0,3.18-1.4,3.18-3.09V8.92c.09-.65-.19-1.22-.65-1.59ZM30.73,30.62c0,1.59-1.31,2.99-2.9,2.99H7.91c-1.59,0-2.9-1.31-2.9-2.99h0V4.99c0-1.59,1.31-2.99,2.9-2.99h15.44c.47,0,.94.19,1.31.56l5.52,5.43c.37.37.65.94.56,1.5v21.14Z"
            />
            <g>
              <path
                class="st1"
                d="M2.12,4.71h15.66c.51,0,.92.42.92.96v6.01c0,.53-.41.96-.92.96H1.2v-6.96c0-.53.41-.94.92-.94v-.02Z"
              />
              <path
                class="st6"
                d="M18.63,11.53v.12c0,.53-.41.96-.92.96H1.14v-6.96c0-.53.41-.96.92-.96h.48v2.47c0,2.41,1.87,4.37,4.2,4.37h11.9-.01Z"
              />
              <polygon
                class="st0"
                points="1.14 12.61 3.92 15.88 3.92 12.61 1.14 12.61"
              />
              <g class="st5">
                <text
                  class="unknown"
                  transform="translate(3.17 10.36) scale(.96 1)"
                >
                  <tspan x="0" y="0">
                    {ext}
                  </tspan>
                </text>
              </g>
            </g>
          </svg>
        </div>
      )
    }
  }

  function renderContent() {
    if (inProgress) {
      return <Loader />
    }

    if (thumbnail) {
      return <img src={`${thumbnail}`} alt={name} />
    }

    return renderFileType()
  }

  return <Wrapper className={className}>{renderContent()}</Wrapper>
}
export default FileIcon
